<template>
  <div>
    <div class="login" >
      <a-input addon-before="用户："  default-value="name" v-model="user"/>
    </div>
   <div class="login" >
      <a-input-password addon-before="密码："  default-value="password" v-model="password"/>
    </div>
    <div class="login" >
      <a-button type='primary' @click="login">登录</a-button>
    </div>
  </div> 
</template>


<script>
export default {
  name: 'Login',
  data () {
    return {
      user:"",
      password:""
    }
  },
  methods:{
    login () {
      console.log(this.user)
      console.log(this.password)
      let param = {
        user:this.user,
        password:this.password
      }
      let obj = this.$qs.stringify(param)
      this.$axios({
                method:'post',
                url:'/api/user/login',
                data: obj
            }).then((response) =>{          //这里使用了ES6的语法
                let result = response.data
                if(result["id"])
                {
                  this.$store.dispatch("userLogin",true);
                  localStorage.setItem("Flag","isLogin");
                  
                }
                this.$router.push('/home')
                console.log(response)       //请求成功返回的数据
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                
      })
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.login {
  margin-top:20px;
  margin-left:auto;
  margin-right:auto;
  width:300px

}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue